export default __webpack_public_path__ + "img/75ccb554c51d6bf15259ecfa91c36a9e.svg";